import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import styles from "./Header.module.scss";
import { useClickOutside } from "hooks/useClickOutside";
import AvatarIcon from "components/svgs/AvatarIcon";
import SearchIcon from "components/svgs/SearchIcon";
import LoginIcon from "components/svgs/LoginIcon";
import HamburgerIcon from "components/svgs/HamburgerIcon";
import CloseIcon from "components/svgs/CloseIcon";
import { useLocation, useNavigate } from "react-router-dom";
import LoginPopup from "components/popups/LoginPopup";
import SignupPopup from "components/popups/SignupPopup";
import { useDispatch, useSelector } from "react-redux";
import { googleLogout } from "@react-oauth/google";
import { setCurrentUser } from "store/features/auth/authSlice";
import ArtworkIcon from "components/svgs/ArtworkIcon";
import AlertIcon from "components/svgs/AlertIcon";
import FollowsIcon from "components/svgs/FollowsIcon";
import MessagesIcon from "components/svgs/MessagesIcon";
import ArtistsIcon from "components/svgs/ArtistsIcon";
import FavoritesIcon from "components/svgs/FavoritesIcon";
import GiftsIcon from "components/svgs/GiftsIcon";
import OrderHistoryIcon from "components/svgs/OrderHistoryIcon";
import SettingsIcon from "components/svgs/SettingsIcon";
import LogoutIcon from "components/svgs/LogoutIcon";
import countryDropdownArrow from "../../assets/images/country-dropdown-arrow.png";
import Popup from "reactjs-popup";
import { countryOptions } from "utils/DropdownOptions";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef();
  const mobileMenuRef = useRef();
  const user = useSelector((state) => state.auth.user);
  const [language, setLanguage] = useState("en");
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showSignupPopup, setShowSignupPopup] = useState(false);

  const [showCountriesPopup, setShowCountriesPopup] = useState(false);
  const [countrySearchValue, setCountrySearchValue] = useState("");

  useClickOutside(dropdownRef, () => setShowProfileDropdown(false));
  useClickOutside(mobileMenuRef, () => setShowMobileMenu(false));

  const handleLogout = () => {
    googleLogout();
    dispatch(setCurrentUser(null));
  };

  useEffect(() => {
    if (showMobileMenu) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [showMobileMenu]);

  useLayoutEffect(() => {
    function handleResize() {
      const appContent = document.querySelector(".app-content");
      const header = document.querySelector("header");
      const stickyArticle = document.querySelector(".stickyArticle");
      const stickySidebar = document.querySelector(".stickySidebar");
      const stickyArtYerkirSidebar = document.querySelector(
        ".stickyArtYerkirSidebar"
      );
      if (appContent && header) {
        appContent.style.marginTop = `${header.offsetHeight}px`;
        if (stickyArticle) {
          stickyArticle.style.top = `${header.offsetHeight + 30}px`;
        }
        if (stickySidebar) {
          stickySidebar.style.top = `${header.offsetHeight + 30}px`;
        }
        if (stickyArtYerkirSidebar) {
          stickyArtYerkirSidebar.style.top = `${header.offsetHeight + 30}px`;
        }
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [location.pathname]);

  return (
    <header className={styles.header}>
      <div className="container">
        <div className={styles.header__top}>
          <div className={styles.header__top__left}>
            <div className={styles.logo} onClick={() => navigate("/")}>
              PAAH
            </div>
            <div className={styles.searchField}>
              <input type="text" placeholder="Search..." />
              <div className={styles.searchIcon}>
                <SearchIcon />
              </div>
            </div>
          </div>
          <div className={styles.header__top__middle}>
            <ul>
              <li
                onClick={() => navigate("country/Artsakh")}
                className={
                  location.pathname === "/country/Artsakh" ? styles.active : ""
                }
              >
                Artsakh
              </li>
              <li
                onClick={() => navigate("country/Armenia")}
                className={
                  location.pathname === "/country/Armenia" ? styles.active : ""
                }
              >
                Armenia
              </li>
              <li
                onClick={() => navigate("country/France")}
                className={
                  location.pathname === "/country/France" ? styles.active : ""
                }
              >
                France
              </li>
              <li
                onClick={() => navigate("country/Russia")}
                className={
                  location.pathname === "/country/Russia" ? styles.active : ""
                }
              >
                Russia
              </li>
              <li
                onClick={() => navigate("country/USA")}
                className={
                  location.pathname === "/country/USA" ? styles.active : ""
                }
              >
                USA
              </li>
              <li onClick={() => setShowCountriesPopup(true)}>
                <img
                  src={countryDropdownArrow}
                  alt="Country"
                  style={{ width: "24px" }}
                />
              </li>
            </ul>
          </div>
          <div className={styles.header__top__right}>
            <div className={styles.userProfileContainer}>
              <div
                ref={dropdownRef}
                className={styles.avatarIcon}
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
              >
                {!user ? (
                  <AvatarIcon />
                ) : (
                  <div className={styles.currentUserImage}>
                    <img src={user.picture} alt={user.name} />
                  </div>
                )}
                {showProfileDropdown ? (
                  <div className={styles.profileDropdown}>
                    {!user ? (
                      <>
                        <div
                          className={styles.dropdownItem}
                          onClick={() => setShowLoginPopup(true)}
                        >
                          <span>Log In</span>
                          <LoginIcon />
                        </div>
                        <div
                          className={styles.dropdownItem}
                          onClick={() => setShowSignupPopup(true)}
                        >
                          <span>Sign Up</span>
                          <LoginIcon />
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={styles.userInfo}>
                          <div className={styles.userImage}>
                            <img src={user.picture} alt={user.name} />
                          </div>
                          <div className={styles.userNameWithLink}>
                            <div className={styles.userName}>{user.name}</div>
                            <div className={styles.viewProfile}>
                              View Profile
                            </div>
                          </div>
                        </div>
                        <div
                          className={styles.dropdownItem}
                          onClick={() => navigate("/my-profile/artworks")}
                        >
                          <ArtworkIcon />
                          <span>Artworks</span>
                        </div>
                        <div className={styles.dropdownItem}>
                          <AlertIcon />
                          <span>Alerts</span>
                        </div>
                        <div className={styles.dropdownItem}>
                          <FollowsIcon />
                          <span>Follows</span>
                        </div>
                        <div className={styles.divider} />
                        <div className={styles.dropdownItem}>
                          <MessagesIcon />
                          <span>Messages</span>
                        </div>
                        <div className={styles.dropdownItem}>
                          <ArtistsIcon />
                          <span>Artists</span>
                        </div>
                        <div className={styles.divider} />
                        <div className={styles.dropdownItem}>
                          <FavoritesIcon />
                          <span>Favorites</span>
                        </div>
                        <div className={styles.dropdownItem}>
                          <GiftsIcon />
                          <span>Gifts</span>
                        </div>
                        <div className={styles.dropdownItem}>
                          <OrderHistoryIcon />
                          <span>Order History</span>
                        </div>
                        <div className={styles.divider} />
                        <div className={styles.dropdownItem}>
                          <SettingsIcon />
                          <span>Settings</span>
                        </div>
                        <div
                          className={styles.dropdownItem}
                          onClick={handleLogout}
                        >
                          <LogoutIcon />
                          <span>Log out</span>
                        </div>
                      </>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.languages}>
              <div
                className={language === "en" ? styles.active : ""}
                onClick={() => setLanguage("en")}
              >
                EN/
              </div>
              <div
                className={language === "arm" ? styles.active : ""}
                onClick={() => setLanguage("arm")}
              >
                ARM/
              </div>
              <div
                className={language === "ru" ? styles.active : ""}
                onClick={() => setLanguage("ru")}
              >
                RU/
              </div>
              <div
                className={language === "fr" ? styles.active : ""}
                onClick={() => setLanguage("fr")}
              >
                FR/
              </div>
            </div>
            <div
              className={styles.hamburgerIcon}
              onClick={() => setShowMobileMenu(true)}
            >
              <HamburgerIcon />
            </div>
            <div
              className={`${styles.mobileMenuBackdrop} ${
                showMobileMenu ? styles.show : styles.hide
              }`}
            >
              <div ref={mobileMenuRef} className={styles.mobileMenuContainer}>
                <div className={styles.mobileMenuHeader}>
                  <div className={styles.languages}>
                    <div
                      className={language === "en" ? styles.active : ""}
                      onClick={() => setLanguage("en")}
                    >
                      EN/
                    </div>
                    <div
                      className={language === "arm" ? styles.active : ""}
                      onClick={() => setLanguage("arm")}
                    >
                      ARM/
                    </div>
                    <div
                      className={language === "ru" ? styles.active : ""}
                      onClick={() => setLanguage("ru")}
                    >
                      RU/
                    </div>
                    <div
                      className={language === "fr" ? styles.active : ""}
                      onClick={() => setLanguage("fr")}
                    >
                      FR/
                    </div>
                  </div>
                  <div
                    className={styles.closeIcon}
                    onClick={() => setShowMobileMenu(false)}
                  >
                    <CloseIcon />
                  </div>
                </div>
                <div className={styles.searchField}>
                  <input type="text" placeholder="Search..." />
                  <div className={styles.searchIcon}>
                    <SearchIcon />
                  </div>
                </div>
                <div className={styles.navbarContainer}>
                  <ul className={styles.navbar}>
                    <li>
                      About Us
                      <div className={styles.navbarDropdownContainer}>
                        <div className={styles.navbarDropdown}>
                          <div className={styles.dropdownItems}>
                            <div className={styles.dropdownItem}>
                              Who We Are
                            </div>
                            <div className={styles.dropdownItem}>
                              Founder's Message
                            </div>
                            <div className={styles.dropdownItem}>
                              Mission and Goals
                            </div>
                            <div className={styles.dropdownItem}>Our Team</div>
                            <div className={styles.dropdownItem}>Feedbacks</div>
                            <div className={styles.dropdownItem}>
                              Contact Information
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li
                      onClick={() => {
                        navigate("/painters");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/painters" ? styles.active : ""
                      }
                    >
                      Artists
                    </li>
                    <li
                      onClick={() => {
                        navigate("/paintings");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/paintings" ? styles.active : ""
                      }
                    >
                      Paintings
                    </li>
                    <li>Sculptures</li>
                    <li>Events</li>
                    <li
                      onClick={() => {
                        navigate("/galleries");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/galleries" ? styles.active : ""
                      }
                    >
                      Galleries
                    </li>
                    <li>Museums</li>
                    <li
                      onClick={() => {
                        navigate("/pan-armenian-arthub");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/pan-armenian-arthub"
                          ? styles.active
                          : ""
                      }
                    >
                      PAAH
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guide");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/guide" ? styles.active : ""
                      }
                    >
                      Guide
                    </li>
                    <li className={styles.disabled}>Community</li>
                  </ul>
                </div>
                <div className={styles.countriesContainer}>
                  <div className={styles.title}>Countries</div>
                  <ul className={styles.countries}>
                    <li
                      onClick={() => {
                        navigate("country/Artsakh");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/country/Artsakh"
                          ? styles.active
                          : ""
                      }
                    >
                      Artsakh
                    </li>
                    <li
                      onClick={() => {
                        navigate("country/Armenia");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/country/Armenia"
                          ? styles.active
                          : ""
                      }
                    >
                      Armenia
                    </li>
                    <li
                      onClick={() => {
                        navigate("country/France");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/country/France"
                          ? styles.active
                          : ""
                      }
                    >
                      France
                    </li>
                    <li
                      onClick={() => {
                        navigate("country/Russia");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/country/Russia"
                          ? styles.active
                          : ""
                      }
                    >
                      Russia
                    </li>
                    <li
                      onClick={() => {
                        navigate("country/USA");
                        setShowMobileMenu(false);
                      }}
                      className={
                        location.pathname === "/country/USA"
                          ? styles.active
                          : ""
                      }
                    >
                      USA
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.header__bottom}>
        <ul className="container">
          <li>
            About Us
            <div className={styles.navbarDropdownContainer}>
              <div className={styles.navbarDropdown}>
                <div className={styles.dropdownItems}>
                  <div className={styles.dropdownItem}>Who We Are</div>
                  <div className={styles.dropdownItem}>Founder's Message</div>
                  <div className={styles.dropdownItem}>Mission and Goals</div>
                  <div className={styles.dropdownItem}>Our Team</div>
                  <div className={styles.dropdownItem}>Feedbacks</div>
                  <div className={styles.dropdownItem}>Contact Information</div>
                </div>
              </div>
            </div>
          </li>
          <li
            onClick={() => {
              navigate("/painters");
            }}
            className={location.pathname === "/painters" ? styles.active : ""}
          >
            Artists
          </li>
          <li
            onClick={() => {
              navigate("/paintings");
            }}
            className={location.pathname === "/paintings" ? styles.active : ""}
          >
            Paintings
          </li>
          <li>Sculptures</li>
          <li>Events</li>
          <li
            onClick={() => {
              navigate("/galleries");
            }}
            className={location.pathname === "/galleries" ? styles.active : ""}
          >
            Galleries
          </li>
          <li>Museums</li>
          <li
            onClick={() => {
              navigate("/pan-armenian-arthub");
            }}
            className={
              location.pathname === "/pan-armenian-arthub" ? styles.active : ""
            }
          >
            PAAH
          </li>
          <li
            onClick={() => {
              navigate("/guide");
            }}
            className={location.pathname === "/guide" ? styles.active : ""}
          >
            Guide
          </li>
          <li className={styles.disabled}>Community</li>
        </ul>
      </div>
      {showLoginPopup ? (
        <LoginPopup
          showLoginPopup={showLoginPopup}
          setShowLoginPopup={setShowLoginPopup}
          setShowSignupPopup={setShowSignupPopup}
        />
      ) : null}
      {showSignupPopup ? (
        <SignupPopup
          showSignupPopup={showSignupPopup}
          setShowSignupPopup={setShowSignupPopup}
          setShowLoginPopup={setShowLoginPopup}
        />
      ) : null}
      {showCountriesPopup ? (
        <Popup
          open={showCountriesPopup}
          onClose={() => {
            setShowCountriesPopup(false);
            setCountrySearchValue("");
          }}
          closeOnDocumentClick={false}
          className="countries-popup"
        >
          <div
            className="close-countries-popup"
            onClick={() => {
              setShowCountriesPopup(false);
              setCountrySearchValue("");
            }}
          >
            <CloseIcon />
          </div>
          <div className="searchField">
            <input
              type="text"
              placeholder="Search Country"
              value={countrySearchValue}
              onChange={(e) => setCountrySearchValue(e.target.value)}
            />
            <div className="searchIcon">
              <SearchIcon />
            </div>
          </div>
          <ul className="countries-popup-list">
            {countryOptions.map((country) => {
              return (
                country.label
                  .toLowerCase()
                  .includes(countrySearchValue.toLowerCase()) && (
                  <li
                    key={country.key}
                    onClick={() => {
                      setShowCountriesPopup(false);
                      setCountrySearchValue("");
                      navigate(`country/${country.key}`);
                    }}
                  >
                    {country.label}
                  </li>
                )
              );
            })}
          </ul>
        </Popup>
      ) : null}
    </header>
  );
};

export default Header;
